<template>
  <div class="main-content auth-content">
    <span>
      <notifications position="top right" />
    </span>
    <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
      <router-view></router-view>
    </zoom-center-transition>
  </div>
</template>
<script>
import { BaseNav } from "@/components";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
  },
  methods: {
    ensureAuthPageTheme() {
      const currentPath = window.location.pathname;
      const isAuthPage = [
        "/login",
        "/register",
        "/forgot-password",
        "/resend-email",
      ].includes(currentPath);

      if (isAuthPage) {
        const token = localStorage.getItem("token");
        const currentRole = localStorage.getItem("role");

        // Auth pages harus selalu member theme, regardless of token status
        console.log("🛡️ Auth page detected - enforcing member theme");

        // Set role ke member
        localStorage.setItem("role", "member");

        // Force load member CSS
        if (typeof window.loadRoleCss === "function") {
          window.loadRoleCss("member", true); // force reload
        }

        // Add body class untuk auth page
        document.body.classList.add("auth-page", "member-theme");
        document.body.classList.remove("partner-theme");

        console.log("Auth theme enforced:", {
          path: currentPath,
          hasToken: !!token,
          roleSet: "member",
        });
      }
    },
    ensureCssConsistency() {
      setTimeout(() => {
        const currentRole = localStorage.getItem("role");
        const roleStyle1 = document.getElementById("role-style-1");

        // Jika di auth page dan CSS tidak sesuai member, reload
        const isAuthPage = [
          "/login",
          "/register",
          "/forgot-password",
          "/resend-email",
        ].includes(this.$route.path);

        if (isAuthPage && (!roleStyle1 || currentRole !== "member")) {
          console.log("CSS inconsistency detected on auth page, fixing...");
          localStorage.setItem("role", "member");
          if (typeof window.loadRoleCss === "function") {
            window.loadRoleCss("member", true);
          }
        }
      }, 500);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
    cleanupAuthPage() {
      document.body.classList.remove("auth-page");
    },
  },
  beforeDestroy() {
    // Cleanup event listeners
    if (this.roleChangeListener) {
      window.removeEventListener("roleChanged", this.roleChangeListener);
    }

    this.removeBackgroundColor();
    this.cleanupAuthPage();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.cleanupAuthPage();
    next();
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();

        this.$nextTick(() => {
          this.ensureAuthPageTheme();
        });
      },
    },
  },
  mounted() {
    this.ensureAuthPageTheme();
    this.ensureCssConsistency();
    this.roleChangeListener = (event) => {
      if (event.detail && event.detail.newRole) {
        console.log("Role change detected in AuthLayout:", event.detail);
        // Jika masih di auth page, paksa kembali ke member
        const isAuthPage = [
          "/login",
          "/register",
          "/forgot-password",
          "/resend-email",
        ].includes(this.$route.path);
        if (isAuthPage && event.detail.newRole !== "member") {
          console.log("Correcting role back to member for auth page");
          localStorage.setItem("role", "member");
          if (typeof window.loadRoleCss === "function") {
            window.loadRoleCss("member", true);
          }
        }
      }
    };
    window.addEventListener("roleChanged", this.roleChangeListener);
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
